import { render, staticRenderFns } from "./CouponTable.vue?vue&type=template&id=66c0266c&scoped=true&"
import script from "./CouponTable.vue?vue&type=script&lang=js&"
export * from "./CouponTable.vue?vue&type=script&lang=js&"
import style0 from "./CouponTable.vue?vue&type=style&index=0&id=66c0266c&lang=scss&scoped=true&"
import style1 from "./CouponTable.vue?vue&type=style&index=1&id=66c0266c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c0266c",
  null
  
)

export default component.exports